var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoLicitaciones,"items-per-page":20},scopedSlots:_vm._u([{key:"item.numero",fn:function( ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{name: 'licitacion', params: { idLicitacion: item.id }}}},[_vm._v("\n        "+_vm._s(item.numero)+"\n      ")])]}},{key:"item.tipo",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"dark":"","color":_vm.getTextoyColor(item.tipo).color}},[_c('span',[_vm._v(_vm._s(_vm.getTextoyColor(item.tipo).texto))])])]}},{key:"item.caracter",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.caracter === 1 ? 'NACIONAL' : '')+"\n    ")]}},{key:"item.normatividad",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.normatividad === 1 ? 'FEDERAL' : 'ESTATAL')+"\n    ")]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"licitacion":item}})]}},{key:"item.fechaConvocatoria",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(new Date(item.fechaConvocatoria).toLocaleDateString())+"\n    ")]}},{key:"item.objeto",fn:function(ref){
var item = ref.item;
return [_c('cortar-texto',{attrs:{"texto":item.objeto}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }